<template lang="pug">
  .tools
    .voice-wrap.pos-a(v-show='showVolume', :class='{"animated fadeIn": showVolume}')
      el-slider(
        v-model='volNum',
        height='100px',
        vertical,
        @change='changeVolume')
    ul.list
      li.list-item(v-if="showFull", @click='handleVoice', @mouseenter='showVolumeBar', @mouseleave='hideVolumeBar')
        i.iconfont(:class="isMuted ? 'icon-volume-close-outline' : 'icon-volume-outline'")
      li.list-item(
        v-for='(item, index) in getMenu',
        :class='{ "active": curIndex === index }'
        :key='index',
        @click='handleMenu(item.name, index)')
        i.iconfont(:class='item.icon')
      li.list-item.full(v-if='showFull', @click='handleFull')
        i.iconfont.icon-full-scene
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import { isPC } from '@/utils'

import { TOOLBAR_VOICE, TOOLBAR_FULL } from '@/config/contant'

export default {
  name: 'tools',
  props: {
    menu: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      curIndex: -1,
      isMuted: false,
      volNum: 100,
      showVolume: false,
    }
  },
  created() {
    this.showFull = isPC() ? 1 : 0
  },
  computed: {
    ...mapGetters(['isShowVR', 'isShowVoice']),
    getMenu() {
      return this.menu
    },
  },
  methods: {
    ...mapActions({
      toggleVisible: 'TOGGLE_VISIBLE_TYPE',
    }),
    showVolumeBar(ev) {
      this.showVolume = true
      clearTimeout(this.volTimer)
    },
    hideVolumeBar(ev) {
      clearTimeout(this.volTimer)
      this.volTimer = setTimeout(() => {
        this.showVolume = false
      }, 2000)
    },
    changeVolume(val) {
      this.isMuted = val === 0 ? 1 : 0
      this.$parent.setVolMuted(val)
      this.hideVolumeBar()
    },
    handleMenu(name, index) {
      this.curIndex = index
      this.toggleVisible(name)
    },
    handleVoice() {
      this.toggleVisible(TOOLBAR_VOICE)
      this.$parent.toggleVolume()
    },
    handleFull() {
      this.toggleVisible(TOOLBAR_FULL)
    },
  },
  watch: {
    isShowVR(val) {
      if (val) {
        this.$krp.showVR()
      } else {
        this.$krp.hideVR()
      }
    },
    isShowVoice(b) {
      this.volNum = b ? 0 : 100
      this.isMuted = b
    },
  },
}
</script>
<style lang="stylus" scoped>
@import '~assets/styles/colors.styl'
$item-width = 45px

.tools
  .list
    .list-item
      color: $--color-white
      cursor: pointer
      overflow: hidden
      text-align: center
      &:hover
        .iconfont
          color: $--theme-color
      .iconfont
        font-size: 28px
        color: $--color-white

.theme-a
  .tools
    .list
      .list-item
        margin-top: 10px
        border-radius: 50%
        background-color: rgba($--color-black, .16)

.theme-b
  .tools
    .voice-wrap
      top: -110px
    .list
      .list-item
        display: inline-block
        line-height: 45px

@media (min-width: 768px)
  .theme-b
    .tools
      .list
        .list-item
          width: $item-width
          height: $item-width
          line-height: $item-width

@media (min-width: 375px) and (max-width: 414px)
  .theme-b
    .tools
      .list
        .list-item
          width: $item-width - 11px
          padding: 0 4px
          .iconfont
            font-size: 22px

@media (max-width: 320px)
  .theme-b
    .tools
      .list
        .list-item
          width: $item-width - 15px
          padding: 0 2px
          .iconfont
            font-size: 20px
</style>
